import { ref } from 'vue'

import scroll from '@/lib/utils/scroll'

export function useScrollAndHighlight() {
  const isSkuBlockOutlined = ref(false)
  const isSkuBlockHighlighted = ref(false)
  const areFieldsHighlighted = ref(false)

  function scrollToDetails(ref) {
    scroll.scrollToElement(ref)
  }
  function scrollToRichText(ref) {
    scroll.scrollToElement(ref)
  }

  function highlightSku() {
    isSkuBlockHighlighted.value = !isSkuBlockHighlighted.value
    setTimeout(() => {
      isSkuBlockHighlighted.value = !isSkuBlockHighlighted.value
    }, 1000)
  }
  function highlightFields() {
    areFieldsHighlighted.value = !areFieldsHighlighted.value
    setTimeout(() => {
      areFieldsHighlighted.value = !areFieldsHighlighted.value
    }, 1000)
  }

  async function scrollToSkuBlock(ref) {
    isSkuBlockOutlined.value = true
    await scroll.scrollToElement(ref)
    highlightSku()
  }

  async function scrollToFields() {
    const firstError = document
      .querySelector(
        '.customize-list__item-wrapper .customize-list--fail, .customize-list__item-wrapper .multiselect--orange',
      )
      ?.closest('.customize-list__item-wrapper')
    if (firstError) {
      await scroll.scrollToElement(firstError)
      highlightFields()
    }
  }

  return {
    isSkuBlockOutlined,
    isSkuBlockHighlighted,
    areFieldsHighlighted,
    scrollToDetails,
    scrollToRichText,
    highlightFields,
    scrollToSkuBlock,
    scrollToFields,
  }
}
